import { selfAxios } from "../../../axios/selfAxios.js";
async function opPostRequestCheckByParams(params) {
  const res = await selfAxios.post(`/unifiedcheck/universalCheckApi/requestCheckByParams`, params);
  return res.data;
}
export { opPostRequestCheckByParams };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/universalCheckApi/requestCheckByParams/post.js